import React, { useEffect, useState } from "react";
import {connect} from "react-redux";
import {updateRespondent} from "../../actions";
import {Button, Input, Tooltip} from "reactstrap";
import {FormattedMessage} from "react-intl";
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import moment from "moment/moment";
import api from "../../../../../api";
import {toast} from "react-toastify";


function UserNotes({ user }) {
	const [note, setNote] = useState("");
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);
	const [notes, setNotes] = useState(user?.userNotes);
	const [tooltipIndex, setTooltipIndex] = useState(null);


	const handleAddNote = () => {
		const text = note.trim();
		if (!text) return;

		setError(false)
		setLoading(true)

		api.userNote.postNote(user.id, text)
			.then((data) => {
				if (data?.error) {
					setError(data.error);
					return;
				}

				const newNote = {
					id: data.id,
					note: text,
					createdAt: data.createdAt ?? new Date().toISOString(),
				};

				setNotes((prev) => [newNote, ...prev]);
				setNote("");
			})
			.finally(() => setLoading(false));
	};

	const handleDeleteNote = (note, indexToRemove) => {
		api.userNote.deleteNote(user.id, note.id)
			.then((data) => {
				toast.success('Notatka została usunięta');
				setNotes((prev) =>
					prev.filter((_, index) => index !== indexToRemove)
				);
			})
	};


	return (
		<div className="space-y-4">
			<div className="bg-white rounded-2xl shadow p-4">
			<Input className={'w-100'} type="textarea" placeholder={'Dodaj nową notatkę...'} value={note} invalid={error} onChange={(e) => setNote(e.target.value)}/>
				{error && <div className="alert alert-danger">{error}</div>}
				<div className="direction-group d-flex justify-content-end">
					<div className="direction-right">
						<FormattedMessage id="_.button.save">{
							(message) => <LaddaButton
								className="btn btn-success btn-ladda mb-0 ml-3"
								onClick={handleAddNote}
								loading={loading}
								disabled={!note.trim()}
							>
								{message}
							</LaddaButton>
						}</FormattedMessage>
					</div>
				</div>
				<div className={'mt-3'}>
				{notes && notes.length ? (
					notes.map((n, index) => (
						<div
							key={index}
							className="flex justify-between p-2 position-relative"
						>
							<div className="flex-1 whitespace-pre-wrap">
								<p>Stworzono: {moment(n.createdAt).format('YYYY-MM-DD H:i:s')}</p>
								{n.note}
							</div>

							<span
								id={`deleteNote-${index}`}
								className="fas fa-trash mr-2 pointer position-absolute"
								style={{top: '15px', right: "0px"}}
								onClick={() => handleDeleteNote(n, index)}
								onMouseEnter={() => setTooltipIndex(index)}
								onMouseLeave={() => setTooltipIndex(null)}
							/>

							<Tooltip
								delay={0}
								placement="bottom"
								isOpen={tooltipIndex === index}
								target={`deleteNote-${index}`}
								toggle={() =>
									setTooltipIndex(tooltipIndex === index ? null : index)
								}
							>
								Usuń notatkę
							</Tooltip>
						</div>
					))
				) : (
					<div className="text-sm text-gray-400">Brak notatek</div>
				)}
				</div>
			</div>
		</div>
	);
}

export default connect(null, { updateRespondent })(UserNotes);